import { get, put } from "./axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_NOTIFIER_API_URL;
const application = "Charisma.Leasing";

class NotifierApi {
  static getMyNotifications(page = 1, pageSize = 10) {
    return get(`${url}/notifier?application=${application}&page=${page}&pageSize=${pageSize}`);
  }

  static markNotificationAsRead(notificationId, userId) {
    return put(`${url}/notifier/${notificationId}`, { notificationId, userId, applicationName: application });
  }

  static dismissNotification(notificationId, userId) {
    return put(`${url}/notifier/dismiss/${notificationId}`, { notificationId, userId, applicationName: application });
  }

  static markAllAsRead(userId) {
    return put(`${url}/notifier/all`, { userId, applicationName: application });
  }

  static dismissAllNotifications(userId) {
    return put(`${url}/notifier/dismiss/all`, { userId, applicationName: application });
  }
}

export default NotifierApi;
